import React from 'react';

function Tooltip({ content, children }) {
  return (
    <span className="relative inline-flex items-center group" tabIndex={0}>
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block group-focus:block whitespace-pre rounded-md bg-gray-900 px-2 py-1 text-xs text-white shadow-lg z-50"
      >
        {content}
      </span>
    </span>
  );
}

export default Tooltip;

